const defaultState = {
    error: null,
    fetching: false,
    fetched: false
};

const postUrlFileUploadReducer = (state = defaultState, action) => {
    switch (action.type) {
        case 'VIN_FILE_UPLOAD_FETCH_PENDING': {
            return {
                ...state, error: null, fetching: true
            };
        }
        case 'VIN_FILE_UPLOAD_FETCH_FULFILLED': {
            return {
                ...state, fetching: false, fetched: true, error: null, fileUploaded: true
            };
        }
        case 'VIN_FILE_UPLOAD_FETCH_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: false,
                error: action.payload
            };
        }
        default: {
            break;
        }
    }

    return state;
};

export default postUrlFileUploadReducer;


// WEBPACK FOOTER //
// ./src/reducers/postUrlFileUpload.js